import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InformacoesFornecedor } from 'src/app/model/turismo/informacoesFornecedor.model';

@Component({
  selector: 'app-lista-fornecedores',
  standalone: false,
  templateUrl: './lista-fornecedores.component.html',
  styleUrl: './lista-fornecedores.component.scss'
})
export class ListaFornecedoresComponent {
  constructor(private modalService: NgbModal){}
  @Input() infoFornecedores: InformacoesFornecedor[] = [];

  fecharModal() {
    this.modalService.dismissAll();
  }
}
